function CurrentUserSign() {
    return (
        <div className="currentUserSign">
            <span>you</span>
        </div>
    )
}

export default CurrentUserSign
